import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import LogoSvg2 from '../../svg/logo-svg2';

export default function Main() {
	const instagramLink = 'https://www.instagram.com/fast_solucoesindustriais/';
	const linkedinLink = 'https://linkedin.com/company/fast-solu%C3%A7%C3%B5es-industriais/';

	return (
		<div className={'bg-primary-content text-secondary-content py-8 min-h-72'}>
			<div
				className={'w-full grid md:grid-cols-3 sm:grid-cols-2 sm:grid-rows-none justify-around items-center space-y-4'}>
				<div className={'flex justify-center items-center'}>
					<LogoSvg2 className={'w-56'}/>
				</div>

				{/*<div className={'hidden roboto-medium uppercase space-y-3 sm:grid md:grid-cols-3'}>*/}
				{/*	<div className={'col-span-2 col-start-2'}>*/}
				{/*		<a href={routes.home}>Home</a>*/}
				{/*	</div>*/}
				{/*	<div className={'col-span-2 col-start-2'}>*/}
				{/*		<a href={routes.company}>A Empresa</a>*/}
				{/*		<span className={'cursor-pointer'}>A Empresa</span>*/}
				{/*	</div>*/}
				{/*	<div className={'col-span-2 col-start-2'}>*/}
				{/*		<a href={routes.products}>Produtos</a>*/}
				{/*		<span className={'cursor-pointer'}>Produtos</span>*/}
				{/*	</div>*/}
				{/*	<div className={'col-span-2 col-start-2'}>*/}
				{/*		<a href={routes.services}>Serviços</a>*/}
				{/*		<span className={'cursor-pointer'}>Serviços</span>*/}
				{/*	</div>*/}
				{/*	<div className={'col-span-2 col-start-2'}>*/}
				{/*		<a href={routes.contact}>Contato</a>*/}
				{/*	</div>*/}
				{/*</div>*/}

				<div className={'px-4 md:px-0 flex md:col-span-2 flex-col gap-y-6 roboto-medium '}>
					<div className={'flex items-center gap-x-6'}>
						<FontAwesomeIcon icon={faMapLocationDot} size={'2xl'}/>
						<p>Rod. Vante Rovaris, 123 - Ouro Negro, Forquilhinha - SC, 88850-000</p>
					</div>

					<div className={'flex items-center gap-x-6'}>
						<FontAwesomeIcon icon={faEnvelope} size={'2x'}/>
						max@fastsolucoesindustriais.com.br
					</div>

					<div className={'flex items-center gap-x-6'}>
						<FontAwesomeIcon icon={faPhone} size={'2x'}/>
						(48) 99121-2223
					</div>

					<div className={'flex flex-wrap gap-x-6 gap-y-3'}>
						<div className={'w-full'}>
							Nos acompanhe também nas redes sociais.
						</div>
						<a href={instagramLink} target='_blank' rel="noreferrer"
							className={'rounded-full w-12 h-12 flex items-center justify-center cursor-pointer'}>
							<FontAwesomeIcon icon={faInstagram} size={'2x'}/>
						</a>
						<a href={linkedinLink} target='_blank' rel="noreferrer"
							className={'rounded-full w-12 h-12 flex items-center justify-center cursor-pointer'}>
							<FontAwesomeIcon icon={faLinkedinIn} size={'2x'}/>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}